module.exports = __webpack_public_path__ + "img/cover-grading-bg.9b29feac.jpg";